import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '@/lib/api';
import { useAuthStore } from '@/stores/authStore';

export function usePageTracking(): void {
  const location = useLocation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const lastPathRef = useRef<string | null>(null);
  const lastPathTimeRef = useRef<number>(Date.now());
  const lastReferrerRef = useRef<string>(typeof document !== 'undefined' ? document.referrer : '');

  useEffect(() => {
    if (!isAuthenticated) return;

    const path = location.pathname;
    const now = Date.now();

    // Dedupe same path within 1s
    if (lastPathRef.current === path && now - lastPathTimeRef.current < 1000) {
      return;
    }

    const durationMs =
      lastPathRef.current && lastPathRef.current !== path ? now - lastPathTimeRef.current : undefined;
    const referrer = lastPathRef.current ?? lastReferrerRef.current ?? '';

    void api
      .post('/track/page', { path, referrer, durationMs })
      .catch(() => {
        // fail silently
      });

    lastPathRef.current = path;
    lastPathTimeRef.current = now;
  }, [location.pathname, isAuthenticated]);
}
